<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Módulos por usuarios</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">ModuloNombre</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col">RolNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="moduusua in datosPaginados" :key="moduusua.idModuUsua">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(moduusua.idModuUsua)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(moduusua.idModuUsua)" title="Editar">edit_square</i></td>
          <td>{{moduusua.moduloNombre}}</td>
          <td>{{moduusua.usuarioNombre}}</td>
          <td>{{moduusua.rolNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteModuUsua(moduusua.idModuUsua)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idModuUsua" class="form-label">IdModuUsua</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModuUsua" name="idModuUsua" v-model="datoModuUsua.idModuUsua" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoModuUsua.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Modulo -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idModulo" class="form-label"> Modulo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idModulo" name="idModulo" v-model="datoModuUsua.idModulo">
                      <option v-for="modulo in modulos" :value="modulo.idModulo" :key="modulo.idModulo">
                        {{ modulo.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Modulo -->
<!-- Botón Lista de Valores  Rol -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idRol" class="form-label"> Rol</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idRol" name="idRol" v-model="datoModuUsua.idRol">
                      <option v-for="rol in rols" :value="rol.idRol" :key="rol.idRol">
                        {{ rol.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Rol -->
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarModuUsua" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditModuUsua" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      moduusuas : [],
      datoModuUsua : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      modulos: [],
      rols: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchModulos()
    this.fetchRols()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.moduusuas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmoduusuas/nombre/'+this.nombreBusqueda).then(response=>{
          this.moduusuas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.moduusuas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmoduusuas').then(response=>{
      this.moduusuas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.moduusuas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idUsuario'
        ,'idModulo'
        ,'idRol'
      ];
      const requiredFieldsText = [
        'idUsuario'
        ,'idModulo'
        ,'idRol'
      ];
      return validarForm(this.datoModuUsua, requiredFields, requiredFieldsText);
    },
    async guardarModuUsua(){
      if(this.validarForm() === 1){
        try {
          this.datoModuUsua.idUsuario = window.sessionStorage.getItem("idUsuario");
          await api.post('/moduusuas', this.datoModuUsua)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ModuUsua creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditModuUsua(){
      if(this.validarForm() === 1){
        try {
          await api.post('/moduusuas', this.datoModuUsua)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ModuUsua creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoModuUsua={}
      this.titulo   = 'Crear Módulos por usuarios'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idModuUsua){
      this.modalWindow = true
      if(idModuUsua != null){    
           api.get('/vwmoduusuas/'+idModuUsua).then(resp=>{
          this.datoModuUsua = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Módulos por usuarios'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idModuUsua){
      if(idModuUsua != null){
        this.$router.push('/moduusuamd/'+idModuUsua)
      }
    },
    async deleteModuUsua (idModuUsua) {
      try{
        await api.delete('/moduusuas/'+idModuUsua)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchModulos() {
      fetch('http://localhost:8080/api/v1/modulos')
        .then(response => response.json())
        .then(data => {
          this.modulos = data;
        })
        .catch(error => {
          console.error('Error fetching modulos:', error);
        });
    },
    fetchRols() {
      fetch('http://localhost:8080/api/v1/rols')
        .then(response => response.json())
        .then(data => {
          this.rols = data;
        })
        .catch(error => {
          console.error('Error fetching rols:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
